/* @flow */

import { DateTime /* , IANAZone */ } from 'luxon';
import { compose } from 'ramda';
import * as React from 'react';

import { getTimezoneLabel } from 'src/shared/app/timezone/util/timezoneUtils';
import useEventTimezone from 'src/shared/domain/event/hook/useEventTimezone';
import useMembershipTimezone from 'src/shared/domain/membership/hook/useMembershipTimezone';

type Props = {
  date: DateTime,
  className?: string,
  withoutCity?: boolean,
};

const Timezone = ({
  // date: propDate,
  className,
}: // withoutCity
Props): React.Node => {
  // const date = propDate || DateTime.local();

  /*
   |----------------------------------------------------------------------------
   | Hooks
   |----------------------------------------------------------------------------
   */

  const membershipTimezone = useMembershipTimezone();
  const eventTimezone = useEventTimezone();

  const zone = getTimezoneLabel(membershipTimezone || eventTimezone);

  // const offset = IANAZone.create(zone).offset(date.ts);
  // const hours = Math.round(offset / 60);
  // const minutes = offset % 60;
  // const printedOffset = `${offset >= 0 ? "+" : ""}${String(hours).padStart(
  //   2,
  //   "0"
  // )}:${String(minutes).padStart(2, "0")}`;

  // let city = null;

  // if (!withoutCity) {
  //   const index = zone.indexOf("/");
  //
  //   city = index > -1 ? zone.slice(index + 1) : "";
  // }

  /*
   |----------------------------------------------------------------------------
   | Elements
   |----------------------------------------------------------------------------
   */

  return (
    // (GMT {printedOffset}) {city}
    <span className={className}>({zone})</span>
  );
};

export default compose(React.memo)(Timezone);
